import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Checkbox } from '@/core/Checkbox.atom';
import {
  COMPARISON_HEADER,
  COMPARISON_TABLE_PROPS,
  SUMMARY_REPORT_TABLE_HEADERS,
  SUMMARY_REPORT_TABLE_PROPS,
} from '@/summaryReport/summaryData.constants';

interface StatisticsSelectionProps {
  visibleStats: string[];
  toggleVisibleStat: (key: string) => void;
  isCompareMode: boolean;
}

export const StatisticsSelection: React.FunctionComponent<StatisticsSelectionProps> = ({
  visibleStats,
  toggleVisibleStat,
  isCompareMode,
}) => {
  const { t } = useTranslation();

  const groupedStatistics = useMemo(() => {
    const tableHeaders = isCompareMode
      ? SUMMARY_REPORT_TABLE_HEADERS
      : SUMMARY_REPORT_TABLE_HEADERS.filter((header) => header !== COMPARISON_HEADER);
    const tableProps = isCompareMode
      ? [...SUMMARY_REPORT_TABLE_PROPS, ...COMPARISON_TABLE_PROPS]
      : SUMMARY_REPORT_TABLE_PROPS;

    return tableHeaders.map((groupTitle) => ({
      groupTitle,
      props: tableProps.filter((prop) => prop.group === groupTitle),
    }));
  }, [isCompareMode]);

  return (
    <div>
      {groupedStatistics.map((group) => (
        <div key={group.groupTitle} className="mb10">
          <div className="optionHeader">{t(group.groupTitle)}</div>
          {group.props.map((prop) => (
            <Checkbox
              key={prop.key}
              label={t(prop.label)}
              isChecked={visibleStats.includes(prop.key)}
              classes="m5"
              onChange={() => toggleVisibleStat(prop.key)}
            />
          ))}
        </div>
      ))}
    </div>
  );
};
